module.exports = __webpack_public_path__ + "/static/assets/55dd7234aa2ae5cf2177070f41e63463.png";